<template>
  <div class="google-pay-main">
    <div class="googlepay-button-fill">
      <button
        class="googlepay-button"
        type="button"
        @click="startPayment"
        :disabled="disablePaymentButton"
        :class="{ disabled: disablePaymentButton }"
        aria-label="Google Pay"
      ></button>
      <div
        id="container"
        style="min-width: 150px; margin-top: 10px; display: none"
      ></div>
    </div>
  </div>
</template>
<script>
const NO_QR = "NO QR";
import googlePayMixin from "@/mixins/payment/GooglePayMixin";
import RedsysMixin from "@/mixins/payment/RedsysMixin";
import paymentsMixin from "@/mixins/payment/paymentsMixin";

export default {
  name: "googlepay",
  props: [
    "totalPrice",
    "disablePaymentButton",
    "unpaidTotalPrice",
    "tableQR",
    "dividePayment"
  ],
  mixins: [googlePayMixin, RedsysMixin, paymentsMixin],
  data() {
    return {};
  },
  computed: {
    cart() {
      return this.$store.state.cart;
    }
  },
  mounted() {
    this.loadGogglePay();
  },
  methods: {
    async startPayment() {
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        this.$emit("checkQRUpdate", this.checkQR);
        return;
      }

      this.onGooglePayLoaded();
    }
  }
};
</script>
